import React from "react";
import { projects } from "../../data";
import LinkButton from "../Atoms/LinkButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface ProjectCardProps {}

const ProjectCard: React.FC<ProjectCardProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap">
      {projects.map((project) => (
        <div key={project.title} className="flex sm:w-1/2 w-full p-4">
          <div className="px-8 py-10  w-full border-4 border-gray-800 bg-gray-900 ">
            <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
              {project.subtitle}
            </h2>
            <h1 className="title-font text-lg font-medium text-white mb-3">
              {project.title}
            </h1>
            <p className="leading-relaxed mb-6 text-white">
              {project.description}
            </p>
            <LinkButton
              href={project.code}
              target="_blank"
              children={<FontAwesomeIcon icon={faCode} />}
              title={t("projectCard.code")}
              className="text-white bg-green-500 border-0 py-3 px-4 focus:outline-none hover:bg-gray-600 rounded text-lg m-2"
            />
            {project.link !== "" ? (
              <LinkButton
                href={project.link}
                target="_blank"
                children={<FontAwesomeIcon icon={faGlobe} />}
                title={t("projectCard.demo")}
                className="text-white bg-indigo-600 border-0 py-3 px-4 focus:outline-none hover:bg-gray-500 rounded text-lg m-2 disabled"
              />
            ) : (
              ""
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectCard;
